import React from 'react';

import {
  ActivityItemsFragment,
  CreateActivityItemMutationMutationResult,
  UpdateActivityItemMutationMutationResult,
  useActivityQuery,
  useCreateActivityItemMutation,
  useDeleteActivityItemMutation,
  useUpdateActivityItemMutation,
} from '../../../generated/graphql';
import deletePageItem from '../../../helpers/apolloCache/deletePageItem';
import { useManageItem } from '../../../helpers/useManageItem';
import Layout from '../../FormComponents/Layout';
import { pagesQuery } from '../../LeftContainer/graphql';
import { PageItemProps } from '../BasicItem';
import { createSave } from '../BusinessItem/Edit';
import Form, { initialValues, validationSchema } from '../BusinessItem/Form';

type T = ActivityItemsFragment | undefined;
type Z = CreateActivityItemMutationMutationResult | UpdateActivityItemMutationMutationResult;

export const FIELDS: string[] = ['address', 'description', 'email', 'phone', 'website'];

export const ActivityItem: React.FC<PageItemProps> = ({ onSaveHandler }) => {
  const { pageId, itemId, isNew, close } = useManageItem();
  const [create, { loading: creating }] = useCreateActivityItemMutation();
  const [update, { loading: updating }] = useUpdateActivityItemMutation();
  const [destroy, { loading: deleting }] = useDeleteActivityItemMutation();

  const { data, loading } = useActivityQuery({
    variables: {
      pageId,
      id: itemId!,
    },
    skip: isNew,
  });

  const item = data?.page?.activityItem;
  const save = createSave<T, Z>({ update, create, pageId, itemId, close, onSaveHandler, fields: FIELDS });

  const onDelete = async () => {
    if (itemId) {
      await destroy({
        variables: {
          attributes: {
            id: itemId,
            pageId,
          },
        },
        update(cache) {
          deletePageItem({ cache, pageId, itemId });
        },
        refetchQueries: [{ query: pagesQuery }],
      });
    }
  };

  return (
    <Layout
      headerText={`${isNew ? 'Add' : 'Update'} an Activity`}
      validationSchema={validationSchema}
      initialValues={initialValues<ActivityItemsFragment>(item)}
      onSubmit={save}
      Component={Form}
      loading={loading}
      updating={updating || creating || deleting}
      close={close}
      pageId={pageId}
      isNew={isNew}
      onDelete={onDelete}
    />
  );
};
